var scope_0 = require('/Users/lalomartinez/Lalo/lalo-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/266e50cc461762010382efae5cf42036.js').default;
var scope_1 = require('/Users/lalomartinez/Lalo/lalo-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ab493d3c683e3ab4208a4330998b02c3.js').default;
var scope_2 = require('/Users/lalomartinez/Lalo/lalo-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c5dde05f480de9f33c1cb2cf7bca8d54.js').default;
var scope_3 = require('/Users/lalomartinez/Lalo/lalo-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    